import axios from 'lib/axios';
import { DebugLogger } from 'lib/debugLogger';
import { aiRmvBgrndDebug } from 'reactApp/appHelpers/featuresHelpers/features/imageTools';
import { sendErrorRadar } from 'reactApp/modules/aiTools/helpers/SendErrorRadar';

export const aiBckgrRmvDebugLogger = new DebugLogger({ DEBUG_SCOPE: 'BackGroundRmv', DEBUG: aiRmvBgrndDebug });

async function fetchFile(fileUrl: string, directDownload = false, withCredentials = true) {
    if (directDownload) {
        const { data: response } = await axios.get<ArrayBuffer>(fileUrl, {
            withCredentials,
            responseType: 'arraybuffer',
        });
        return response;
    }

    const { data: response } = await axios.get<{ redirect: string }>(fileUrl, {
        withCredentials,
        params: {
            no_redirect: true,
        },
    });
    const { data: contentBuffer } = await axios.get<ArrayBuffer>(response.redirect, { responseType: 'arraybuffer' });
    return contentBuffer;
}

export async function getFileAsDataUrl(url = '', ext = 'jpg', directDownload = false, withCredentials = true) {
    if (!url) {
        return;
    }

    try {
        const array = await fetchFile(url, directDownload, withCredentials);

        const base64String = btoa(new Uint8Array(array).reduce((data, byte) => data + String.fromCharCode(byte), ''));

        return `data:image/${ext};base64,${base64String}`;
    } catch (error: any) {
        aiBckgrRmvDebugLogger.error('getFileAsDataUrl', error);
        sendErrorRadar('fetchfile', error?.message);
        return null;
    }
}

export const getNetworkInfo = () => {
    try {
        // @ts-ignore
        // eslint-disable-next-line compat/compat
        const effType = 'effectiveType' in navigator.connection && navigator.connection.effectiveType;
        // eslint-disable-next-line compat/compat
        const type = navigator.connection && 'type' in navigator.connection && navigator.connection.type;
        return `${effType}${type ? `(${type})` : ''}`;
    } catch {}
};

class ProcessedFileCache {
    private _transparent: Record<string, ArrayBuffer> = {};
    private _newBackground: Record<string, ArrayBuffer> = {};

    public getTansparent(id: string): ArrayBuffer {
        return this._transparent[id];
    }

    public setTransparent(id: string, value: ArrayBuffer | null = null) {
        if (!value) {
            delete this._transparent[id];
            return;
        }
        this._transparent[id] = value;
    }

    public getNewBackground(id: string): ArrayBuffer {
        return this._newBackground[id] || this._transparent[id];
    }

    public setNewBackground(id: string, value: ArrayBuffer | null = null) {
        if (!value) {
            delete this._newBackground[id];
            return;
        }
        this._newBackground[id] = value;
    }
}

export const processedFileCache = new ProcessedFileCache();
